import React, { useState } from "react";

import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import Authentication from "../../../../../../infra/cognito/authentication";

import Login from "../../../../../../presentation/pages/auth/admin/login";

import toastUtils from "../../../../../../utils/ToastUtils";
import { t } from "../../../../../../presentation/adapters/translate/translate";

function MakeSignInAdmin(): JSX.Element {
  const rememberMe = localStorage.getItem("rememberMeAdmin");

  const [errorMessage] = useState<string | null>("");

  const { reloadAuth } = useAuthGlobal();

  const handleSubmit = async (values: any): Promise<void> => {
    if (values?.rememberMe[0]) {
      localStorage.setItem("rememberMeAdmin", values?.email);
    } else {
      localStorage.removeItem("rememberMeAdmin");
    }

    try {
      await Authentication.login(values.email, values.password);
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: t(error.code, error.message),
      });
    } finally {
      reloadAuth();
    }
  };

  const handleRememberMeChange = (value: any, el: any): void => {
    if (value[0]) {
      localStorage.setItem("rememberMeAdmin", el?.values?.email);
    } else {
      localStorage.removeItem("rememberMeAdmin");
    }
  };

  const dataForm = [
    {
      items: [
        {
          component: "Input",
          name: "email",
          title: "E-mail",
          label: "E-mail",
          value: rememberMe ?? "",
          validations: "inputRequired",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "password",
          title: "Senha",
          label: "Senha",
          validations: "inputRequired",
        },
        {
          component: "InputGroup",
          style: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          },
          inputs: [
            {
              component: "InputCheck",
              name: "rememberMe",
              title: "",
              label: "",
              onChange: handleRememberMeChange,
              checked: rememberMe ?? false,
              options: [
                {
                  value: "true",
                  label: "Lembrar-me",
                  name: "Lembrar-me",
                },
              ],
            },
            {
              component: "Link",
              title: "Esqueci minha senha",
              href: "/admin/forgot-password",
            },
          ],
        },
        {
          name: "button",
          component: "Button",
          title: "Entrar",
          submittingText: "Entrando...",
        },
      ],
    },
  ];

  const props = {
    dataForm,
    errorMessage,
    onSubmit: handleSubmit,
  };

  return <Login {...props} />;
}

export default MakeSignInAdmin;
